var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
var MetadataUpdateModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onUpdate = _a.onUpdate, data = _a.data;
    var _b = useState(''), DBName = _b[0], setDBName = _b[1];
    var _c = useState(''), tableName = _c[0], setTableName = _c[1];
    var _d = useState(''), configName = _d[0], setConfigName = _d[1];
    var _e = useState([]), fields = _e[0], setFields = _e[1];
    var _f = useState(false), isAllTables = _f[0], setIsAllTables = _f[1];
    var _g = useState(false), isAllFields = _g[0], setIsAllFields = _g[1];
    // Helper function to extract table names from the table object
    var getTableNamesFromTableObj = function (tableObj) {
        if (!tableObj)
            return '';
        if (tableObj.all === true) {
            return 'All Tables/Collections';
        }
        var tableNames = Object.keys(tableObj).filter(function (key) { return key !== 'all'; });
        return tableNames.join(', ');
    };
    // Helper function to extract fields from the table object
    var getFieldsFromTableObj = function (tableObj) {
        if (!tableObj)
            return [];
        if (tableObj.all === true) {
            return [];
        }
        var tableNames = Object.keys(tableObj).filter(function (key) { return key !== 'all'; });
        var allFields = [];
        for (var _i = 0, tableNames_1 = tableNames; _i < tableNames_1.length; _i++) {
            var tableName_1 = tableNames_1[_i];
            var tableConfig = tableObj[tableName_1];
            if (tableConfig.fields && Array.isArray(tableConfig.fields)) {
                allFields.push.apply(allFields, tableConfig.fields);
            }
        }
        return allFields;
    };
    // Helper function to check if all tables are selected
    var checkIfAllTables = function (tableObj) {
        return tableObj && tableObj.all === true;
    };
    // Helper function to check if all fields are selected for a table
    var checkIfAllFields = function (tableObj) {
        if (!tableObj || tableObj.all === true)
            return false;
        var tableNames = Object.keys(tableObj).filter(function (key) { return key !== 'all'; });
        if (tableNames.length === 0)
            return false;
        // Check if any table has "all": true
        return tableNames.some(function (tableName) { return tableObj[tableName].all === true; });
    };
    useEffect(function () {
        if (isOpen && data) {
            setDBName(data.DBName);
            setConfigName(data.configName);
            // Extract table names and fields from the new structure
            var tableNames = getTableNamesFromTableObj(data.table);
            var extractedFields = getFieldsFromTableObj(data.table);
            setTableName(tableNames);
            setFields(extractedFields);
            setIsAllTables(checkIfAllTables(data.table));
            setIsAllFields(checkIfAllFields(data.table));
        }
    }, [isOpen, data]);
    var handleFieldChange = function (index, key, value) {
        var updatedFields = __spreadArray([], fields, true);
        updatedFields[index][key] = value;
        setFields(updatedFields);
    };
    var handleAddField = function () {
        setFields(__spreadArray(__spreadArray([], fields, true), [{ field: '', type: '', isEncrypted: false }], false));
    };
    var handleRemoveField = function (index) {
        setFields(fields.filter(function (_, i) { return i !== index; }));
    };
    // Helper function to reconstruct the table object for update
    var reconstructTableObject = function () {
        if (isAllTables) {
            return { all: true };
        }
        // For now, we'll keep the original structure since we're only displaying
        // In a real scenario, you'd need more complex logic to handle table name changes
        return data.table;
    };
    if (!isOpen)
        return null;
    return (_jsx("div", { className: 'fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50', children: _jsxs("div", { className: 'bg-white rounded-lg shadow-lg w-full max-w-2xl', children: [_jsx("div", { className: 'bg-blue-100 text-center py-4 rounded-t-lg', children: _jsx("h2", { className: 'text-lg font-semibold text-gray-800', children: "Update Metadata Configuration" }) }), _jsxs("div", { className: 'px-6 py-5 space-y-4 max-h-[80vh] overflow-y-auto', children: [_jsx(InputField, { label: 'Database Name', value: DBName, onChange: setDBName }), _jsxs("div", { className: 'w-full', children: [_jsxs("label", { className: 'block text-sm font-medium text-gray-700 mb-1', children: ["Table Name ", _jsx("span", { className: 'text-red-500', children: "*" })] }), _jsx("input", { type: 'text', className: 'w-full px-3 py-2 rounded-md border border-gray-300 bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500', value: tableName, onChange: function (e) { return setTableName(e.target.value); }, disabled: isAllTables, placeholder: isAllTables ? 'All tables selected' : 'Enter table names' }), isAllTables && (_jsx("p", { className: 'text-xs text-gray-500 mt-1', children: "All tables/collections are selected for this configuration" }))] }), _jsx(InputField, { label: 'Config Name', value: configName, onChange: setConfigName }), _jsxs("div", { children: [_jsx("h3", { className: 'text-md font-medium mt-4 mb-2', children: "Fields" }), isAllTables ? (_jsx("div", { className: 'bg-blue-50 border border-blue-200 rounded-md p-3', children: _jsx("p", { className: 'text-sm text-blue-700', children: "All fields from all tables are selected for encryption in this configuration." }) })) : isAllFields ? (_jsx("div", { className: 'bg-green-50 border border-green-200 rounded-md p-3', children: _jsx("p", { className: 'text-sm text-green-700', children: "All fields from the selected table(s) are configured for encryption." }) })) : fields.length > 0 ? (fields.map(function (field, index) { return (_jsxs("div", { className: 'border rounded-md p-3 bg-gray-50 mb-3 space-y-2', children: [_jsxs("div", { className: 'flex gap-4', children: [_jsx(InputField, { label: 'Field Name', value: field.field, onChange: function (val) { return handleFieldChange(index, 'field', val); }, disabled: field.isEncrypted }), _jsx(InputField, { label: 'Type', value: field.type, onChange: function (val) { return handleFieldChange(index, 'type', val); }, disabled: field.isEncrypted })] }), _jsxs("div", { className: 'flex items-center gap-2', children: [_jsx("label", { className: 'text-sm font-medium text-gray-700', children: "Encrypted:" }), _jsx("input", { type: 'checkbox', checked: field.isEncrypted, onChange: function (e) { return handleFieldChange(index, 'isEncrypted', e.target.checked); } }), _jsx("button", { onClick: function () { return handleRemoveField(index); }, className: 'ml-auto text-red-600 text-sm hover:underline cursor-pointer', children: "Remove" })] })] }, index)); })) : (_jsx("div", { className: 'bg-gray-50 border border-gray-200 rounded-md p-3', children: _jsx("p", { className: 'text-sm text-gray-600', children: "No specific fields configured. This might be a complete table selection." }) }))] }), _jsxs("div", { className: 'flex justify-end gap-4 mt-4', children: [_jsx("button", { onClick: onClose, className: 'px-5 py-2 rounded-md bg-gray-200 text-gray-800 font-medium hover:bg-gray-300 transition cursor-pointer', children: "Cancel" }), _jsx("button", { onClick: function () {
                                        return onUpdate(__assign(__assign({}, data), { DBName: DBName, configName: configName, table: reconstructTableObject() }));
                                    }, className: 'px-5 py-2 rounded-md bg-blue-600 text-white font-medium hover:bg-blue-700 transition cursor-pointer', children: "Update" })] })] })] }) }));
};
var InputField = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, placeholder = _a.placeholder, _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    return (_jsxs("div", { className: 'w-full', children: [_jsxs("label", { className: 'block text-sm font-medium text-gray-700 mb-1', children: [label, " ", _jsx("span", { className: 'text-red-500', children: "*" })] }), _jsx("input", { type: type, className: 'w-full px-3 py-2 rounded-md border border-gray-300 bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500', placeholder: placeholder, value: value, onChange: function (e) { return onChange(e.target.value); }, disabled: disabled })] }));
};
export default MetadataUpdateModal;
